import { Check } from "@phosphor-icons/react";
import { useInView } from "@/hooks/useInView";

const outcomes = [
  "Composure and regulated presence under pressure",
  "Stronger situational awareness in any environment",
  "Practical self-defense skill and physical confidence",
  "Strategic communication and boundary-setting",
  "Leadership-ready strength and executive composure",
  "Career-protective clarity in high-stakes situations",
];

const TEXTURE_IMG = "https://static.prod-images.emergentagent.com/jobs/117cf0fb-3794-49a5-86c5-1fbf8d876a37/images/af8a73efce050d92fb0ab5435059cc22a155d6dd30abbe046fcc01f75527abdf.png";

export default function OutcomesSection() {
  const [ref, inView] = useInView();

  return (
    <section data-testid="outcomes-section" className="relative py-16 sm:py-20 overflow-hidden" ref={ref}>
      <div className="absolute inset-0">
        <img src={TEXTURE_IMG} alt="" className="w-full h-full object-cover opacity-15" />
        <div className="absolute inset-0 bg-gradient-to-b from-[#050505]/90 via-[#050505]/70 to-[#050505]/90" />
      </div>
      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8">
        <p className={`text-xs tracking-[0.2em] uppercase font-bold text-[#D4AF37] font-body mb-4 reveal ${inView ? 'visible' : ''}`}>Outcomes</p>
        <h2 className={`font-heading text-3xl sm:text-4xl font-bold tracking-tight text-[#F2EFE9] mb-12 max-w-lg reveal ${inView ? 'visible' : ''} stagger-1`}>
          What changes for you.
        </h2>
        <div className="grid sm:grid-cols-2 gap-5 max-w-2xl">
          {outcomes.map((o, i) => (
            <div
              key={o}
              data-testid="outcome-item"
              className={`flex items-start gap-3 group glass-subtle rounded-lg p-3 hover:bg-white/5 transition-all reveal ${inView ? 'visible' : ''} stagger-${i + 1}`}
            >
              <Check size={20} weight="bold" className="text-[#D4AF37] mt-0.5 flex-shrink-0 group-hover:scale-110 transition-transform" />
              <p className="text-[#F2EFE9] font-body text-sm leading-relaxed">{o}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
